import { Result } from '@cplug/frontend-core/utils'
import { CPAppGateway } from '~/domain/dashboard/app/apps/gateways/CPAppGateway'
import type { TenantStoreDomain } from '~/domain/dashboard/app/apps/gateways/DTOs/TenantStoreDomainDTO'

export type { TenantStoreDomain }

/** Loads the tenant store domain even when the current company has no store app yet. */
export function fetchTenantStoreDomain (): Promise<Result<TenantStoreDomain>> {
  return CPAppGateway.instance().getTenantStoreDomain()
}
